<script setup lang="ts">
import type { IconSize, TpgClickEvent, TpgInputEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';
import type { Slot } from 'vue';

import type { GrammarFABToggleType } from './component-types';

export interface GrammarFABToggleProps {
  type?: GrammarFABToggleType;
  size?: 'regular';
  selected?: boolean;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  iconTemplate?: IconConstant | '';
  iconPosition?: 'leading' | 'trailing' | 'top';
  iconOnlySize?: IconSize;
}

interface GrammarFABToggleSlots {
  badge?: Slot;
}

const props = withDefaults(defineProps<GrammarFABToggleProps>(), {
  type: 'default',
  size: 'regular',
  selected: false,
  label: '',
  ariaLabel: '',
  disabled: false,
  iconTemplate: '',
  iconPosition: 'leading',
  iconOnlySize: 'large',
});

const emit = defineEmits(['click', 'input']);
const slots = defineSlots<GrammarFABToggleSlots>();
function onClick(event: TpgClickEvent) {
  emit('click', event);
}

function onInput(event: TpgInputEvent<boolean>) {
  emit('input', event);
}
</script>

<template>
  <tpg-fab-toggle v-bind="props" @tpg-click="onClick" @tpg-input="onInput">
    <div v-if="slots.badge" slot="badge" class="inline-block m-0 p-0">
      <slot name="badge" />
    </div>
  </tpg-fab-toggle>
</template>
